export default {
  'm': {
    'uploading': 'Đang tải lên...',
    'upload_failed': 'Tải lên thất bại',
    'EnterID': 'Bấm nhập BuzzCast ID',
    'select-specifications': 'Bấm chọn quy cách nạp tiền',
    'check-account': 'Đối chiếu tài khoản nạp tiền',
    'whatID': 'BuzzCast ID là gì?',
    'getID': 'Nhập BuzzCast ID',
    'maskgetID': 'Nhập BuzzCast ID',
    'toastTipsPlease-format-error': 'Định dạng nhập lỗi',
    'toastTips-no-exist': 'ID này không tồn tại',
    'toastTipsPlease': 'Vui lòng đối chiếu tài khoản nạp tiền',
    'common-problem': 'Vấn đề thường gặp',
    'transaction-succeeded': 'Giao dịch thành công',
    'transaction-failed': 'Giao dịch thất bại',
    'transaction-cancel': 'Hủy giao dịch',
    'whether-account': '1.Sau khi nạp tiền xong làm thế nào để kiểm tra đã vào tài khoản hay chưa?',
    'answer-whether-account': 'Sau khi nạp tiền xong có thể vào 【Tôi】 - 【Ví tiền】 trong app để kiểm tra kim cương',
    'no-account': '2.Sau khi nạp tiền xong nếu không vào tài khoản thì làm thế nào?',
    'answer-no-account': 'Vui lòng gửi vấn đề của bạn tại【Tin tức】-【Tin tức chính thức】-【Phản hồi và Hỗ trợ】 trong app, đồng thời cung cấp những thông tin sau đây, chăm sóc khách hàng của chúng tôi sẽ hỗ trợ cho bạn',
    'recharge-money': '1. Số tiền nạp và ID tài khoản',
    'recharge-time': '2. Thời gian và ngày tháng nạp tiền',
    'recharge-shot': '3. Ảnh chụp màn hình nạp tiền thành công',
    'recharge-wrong': '3.Nạp sai tài khoản, số tiền nạp sai làm thế nào',
    'answer-recharge-wrong': 'Trước khi nhập mật khẩu thanh toán, bạn phải xác nhận lại thông tin về ID tài khoản nạp tiền và số tiền nạp rồi mới tiến hành mua. Số tiền nạp sai không thể trả lại, nạp sai tài khoản bạn có thể thử liên hệ với người dùng có ID đã nhận tiền thực tế, để thỏa thuận với đối phương có trả lại số tiền đã nạp cho bạn hay không.',
    'refund': '4.Hoàn tiền',
    'answer-refund': 'Xin lỗi! Hiện nay BuzzCast không hỗ trợ hoàn tiền với bất kỳ hình thức nào.',
    'buy-enter-link': 'Mua kim cương có thể thông qua đường link để nạp tiền, <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> sao chép đường link vào trình duyệt điện thoại và mở ra, đi vào giao diện mua, sau khi đối chiếu tài khoản, chọn quy cách tương ứng và sử dụng phương thức thanh toán phù hợp để thanh toán là được ~ Cực nhiều ưu đãi!',
    'buy-notice-a': 'Chú ý:<a>{msg}</a> là trang web mua kim cương chính thức duy nhất của BuzzCast',
    'replace': 'Thay đổi',
    'sureBtn': 'Xác định',
    'pay-style': 'Chọn phương thức thanh toán',
    'goBack': 'Quay lại trang chủ',
    'toastTips': 'Nhập BuzzCast ID',
    'rechargeFAQ_title': 'Vấn đề thường gặp',
    'PayStatusSuccess_title': 'Giao dịch thành công',
    'PayStatusFail_title': 'Giao dịch thất bại',
    'PayStatusCancel_title': 'Hủy giao dịch',
    'Diamonds_title': 'Trang web chính thống nạp kim cương {msg} ',
    'buy-notice': 'Lưu ý pay.buzzcast.info là trang web mua kim cương chính thức duy nhất của BuzzCast. Đối với các yêu cầu dịch vụ khách hàng, vui lòng truy cập [Tin nhắn] - [Tin tức chính thức] - [Phản hồi và trợ giúp]',
    'RechargeHelp_title': 'Trợ giúp nạp tiền',
    'feedback_and_help': 'Phản hồi và trợ giúp',
    'problem_screenshot': 'Ảnh chụp màn hình câu hỏi / ghi màn hình ({msg})',
    'problem_description': 'Mô tả câu hỏi',
    'problem_description_placeholder': 'Vui lòng mô tả câu hỏi bạn gặp phải',
    'optional': 'tùy chọn',
    'required': 'yêu cầu',
    'openAPP': 'Ứng dụng BuzzCast mở',
    'buy-diamonds-tit': 'Mua dịch vụ kim cương',
    'description': 'Trang web chính thống nạp kim cương duy nhất BuzzCast, BuzzCast là một ứng dụng mạng xã hội quốc tế, người dùng trên toàn cầu vượt quá 150 quốc gia và khu vực đang sử dụng BuzzCast ',
    'keywords': 'Nạp BuzzCast, nạp kim cương BuzzCast, nạp chính thống BuzzCast, trang web nạp chính thống BuzzCast',
    'payforType': 'Şarj yöntemi',
    'trueText': 'Xác định',
    'falseText': 'Hủy',
    'alertShowTxt1': '',
    'alertShowTxt3': 'Elmasları şarj etmek için',
    'alertShowTxt5': 'kullanacağınızdan emin misiniz?',
    'EnterIDTip': 'Nạp tiền nhanh qua {msg}',
    'scanLogin': 'Vì sự riêng tư và bảo mật của tài khoản, vui lòng quét mã để đăng nhập',
    'scanTip': 'Mẹo: Nhấp vào "Quét" ở góc trên bên phải "Trung tâm cá nhân / Động lực" của BuzzCast để quét mã đăng nhập. Đồng thời hỗ trợ đăng nhập bằng cách nhận diện ảnh chụp màn hình mã QR',
    'scanVersion': 'Vui lòng nâng cấp BuzzCast lên phiên bản %s và quét mã để đăng nhập',
    'delAccount': 'Xóa tài khoản',
    'logout': 'Thoát',
    'submit': 'Đệ trình',
    'email_place_holder': 'Nhập email của bạn',
    'fill_in_email_address': 'Vui lòng điền vào địa chỉ email',
    'fill_in_all_required': 'Vui lòng nhập mô tả câu hỏi',
    'order_exception_notice': 'Nhắc nhở ấm áp: Số đơn đặt hàng hoặc ảnh chụp màn hình hóa đơn phải được cung cấp cho các đơn hàng nạp tiền bất thường',
    'cannot_read_file': 'Không thể đọc tệp',
    'submitting': 'Đang gửi...',
    'submit_failed': 'Gửi thất bại',
    'contact_email': 'Địa chỉ email liên lạc',
    'provide_email': 'Vui lòng cung cấp địa chỉ email của bạn để nhận thông báo thanh toán',
    'email_address': 'Địa chỉ email',
    'sel_country_area': 'Chọn quốc gia hoặc khu vực',
    'search_for': 'Tìm kiếm',
    'login': 'Đăng nhập',
    'scan_login': 'Đăng nhập mã quét',
    'account_password_error': 'Số điện thoại hoặc mật khẩu bị sai',
    'user_frozen': 'Tài khoản đã được khóa',
    'account_no_reg': 'Tài khoản không được đăng ký',
    'login_no': 'Bạn không đăng nhập',
    'login_after_recharge': 'Bạn có thể nạp tiền sau khi đăng nhập',
    'scan_login_lesson': 'Hướng dẫn đăng nhập mã quét',
    'scan_login_desc': 'Phương pháp đăng nhập mã quét có thể nhanh chóng và nhận biết một cách an toàn để đăng nhập trang web nạp tiền. Hai phương thức sau đây sẽ giới thiệu lần lượt cách quét mã để đăng nhập.',
    'scan_login_a_title': 'Đăng nhập bằng cách nhận ra ảnh chụp màn hình của mã QR',
    'scan_login_a_p1': '1. Nó phù hợp hơn để sử dụng kịch bản của thiết bị duy nhất. Người dùng nhập trang đăng nhập của trang web nạp tiền, nhấp để chọn "Quét mã để đăng nhập" và chụp ảnh màn hình của trang với mã QR đăng nhập được hiển thị và lưu album. (Chức năng ảnh chụp màn hình hơi khác nhau đối với các thiết bị khác nhau, bạn có thể tìm kiếm hướng dẫn vận hành của chức năng ảnh chụp màn hình)',
    'scan_login_a_p2': '2. Mở ứng dụng BuzzCast, thông qua mô-đun chức năng "Trung tâm cá nhân" hoặc "Động lực", nhấp vào "Quét" ở góc trên bên phải để vào mô-đun chức năng quét mã.',
    'scan_login_a_p3': '3. Nhấp vào "Lựa chọn album" và cho phép quyền của album, chọn ảnh chụp màn hình trang đăng nhập mã QR đã lưu, nhấp vào nút Xác nhận "Đăng nhập" sau khi hệ thống nhận dạng, chuyển lại trình duyệt và đợi trong một thời gian, trang sẽ tự động tải người dùng thông tin.',
    'scan_login_b_title': 'Đăng nhập bằng cách quét mã QR',
    'scan_login_b_p1': '1. Nó phù hợp hơn cho việc sử dụng nhiều thiết bị. Người dùng nhập trang đăng nhập của trang web nạp tiền và nhấp để chọn Đăng nhập mã quét',
    'scan_login_b_p2': '2. Mở ứng dụng BuzzCast trên một thiết bị khác, đi đến mô-đun chức năng "Trung tâm cá nhân" hoặc "động" và nhấp vào "Quét" ở góc trên bên phải để vào mô-đun chức năng quét mã.',
    'scan_login_b_p3': '3. Căn chỉnh hộp quét mã với mã QR trên trang đăng nhập quét mã, nhấp vào nút Xác nhận "Đăng nhập" sau khi hệ thống nhận dạng nó (nên giữ một khoảng cách nhất định giữa các thiết bị khi quét mã, dễ dàng hơn cho hệ thống nhận dạng). Sau một thời gian, trang sẽ tự động tải thông tin người dùng.',
    'scan_login_lesson_end': 'Trên đây là một hướng dẫn hướng dẫn để đăng nhập mã quét, tôi hy vọng sẽ giúp bạn. Đối với tư vấn dịch vụ khách hàng, vui lòng nhập thông điệp ứng dụng Tin tức chính thức-Phản hồi và Trợ giúp.',
    'or': 'Hoặc',
    'input_phone_num': 'không đựơc để trống số điện thoại',
    'input_email': 'Vui lòng nhập địa chỉ email',
    'input_password': 'Nhập mật khẩu',
    'log_in_using_Facebook': 'Sử dụng Facebookđăng nhập',
    'log_in_using_Google': 'Sử dụng Google đăng nhập',
    'account_or_pwd_error': 'Tài khoản hoặc mật khẩu không chính xác',
    'pay_fail_system_risk': 'Giao dịch không thành công: hệ thống bất thường',
    'recharge_fail_risk_network': 'Nạp tiền thất bại. Bạn có thể đang ở trong môi trường mạng có rủi ro cao hoặc vì các lý do khác. Nếu bạn cần trợ giúp về nạp tiền, vui lòng phản ánh vấn đề cho chúng tôi.',
    'friendly_tip': 'Mẹo thân thiện',
    'i_got_it': 'Tôi hiểu rồi',
    'android_fblogin_tip': 'Vì Facebook không còn hỗ trợ đăng nhập xác thực trên trình duyệt nhúng Android nên bạn có thể không đăng nhập được khi đăng nhập theo cách này. Nếu bạn gặp phải loại sự cố đăng nhập này, vui lòng sử dụng trình duyệt Chrome để truy cập.',
    'recharge_tip': 'Số lượng kim cương nhận được cụ thể tùy thuộc vào số lượng nạp thực tế',
    'charge': 'Nạp tiền',
    'link_add_mainpage': 'Thêm liên kết vào màn hình chính để tải lại lần sau',
    'click_me_to_add': 'Nhấp vào tôi để thêm',
    'user_has_delete': 'Người dùng đã bị hủy',
    'support_contant_whatsapp': 'Nếu bạn cần hỗ trợ, vui lòng liên hệ với dịch vụ khách hàng trên {msg} App：1924383',
    'buy_balance': 'Số dư có thể mua:',
    'official_coin_seller': 'Nhà buôn tiền xu chính thức',
    'paystyle_unavailabel_change_other': 'Hệ thống bất thường, phương thức thanh toán này tạm thời không khả dụng, bạn có thể thay đổi phương thức thanh toán khác.',
    'failedPay': 'Thanh toán gặp vấn đề, thanh toán lại',
    "copied": "Đã sao chép",
    "reseller": "Đại lý",
    "netword_busy_try": "Mạng đang bận, vui lòng thử lại",
    "placecommen": 'Nhập nội dung tìm kiếm',
    "app_all_v2": 'Toàn bộ',

		"use_phone_login": `Đăng nhập bằng điện thoại`,
    "use_email_login": `Đăng nhập bằng email`,
    "device_is_more": "Thiết bị này đã đăng ký 6 tài khoản, vui lòng thay đổi thiết bị khi đăng ký",
    "Operation_failed": "Thiết bị này đã bị đóng băng vĩnh viễn do vi phạm tài khoản",
    "connection_fail_retry_feedback": "Kết nối thất bại. Vui lòng đảm bảo mạng ổn định và thử lại. Nếu vẫn gặp lỗi, vui lòng phản ánh cho chúng tôi, chúng tôi sẽ giải quyết cho bạn trong thời gian sớm nhất.",
    "fawry_recharge_failed": "Nạp tiền ${msg} qua {method} không thành công.",
    "feedback": "Phản hồi",
    "problem_feedback": "Phản hồi",
    "recommended_recharge_methods": "Phương thức thanh toán được đề xuất",
    "try_recharge_methods": "Vui lòng thử nạp tiền bằng các phương thức sau. Nếu bạn vẫn gặp sự cố, hãy nhấp vào nút \"{feedback}\" bên dưới để liên hệ với chúng tôi.",
    "unable_recharge": "Không thể nạp tiền",
    "submitted_successfully": "Gửi thành công",
    "feedback_success_tip": "Cảm ơn bạn đã phản hồi, chúng tôi sẽ giải quyết nó sớm nhất có thể trong vòng 24 giờ",
    "completed": "Hoàn thành",
    'contact_information': 'Chi tiết liên hệ (tùy chọn)',
    'pay_failed': 'Thanh toán thất bại',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/vi.js